module.exports = __webpack_public_path__ + "img/green-1-squiggly-solid.74bed98e.svg";